import React from 'react';
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import AuthForm from './AuthForm';

function AuthDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] p-0">
        <AuthForm onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}

export default AuthDialog; 